import * as z from "zod";

export const LoginSchema = z.object({
  email: z
    .string()
    .min(1, { message: "Email is required" })
    .email({ message: "Invalid email address" }),
  password: z.string().min(1, { message: "Password is required" }),
  rememberMe: z.boolean().default(false).optional(),
});

export const InviteSchema = z
  .object({
    fullName: z.string().min(1, { message: "Fullname is required" }),
    password: z
      .string()
      .min(1, { message: "Password is required" })
      .refine((val) => {
        return /[a-z]/.test(val) && /[A-Z]/.test(val) && /[0-9]/.test(val);
      }),
    confirm_password: z.string(),
    inviteToken: z.string().min(1, { message: "Invite token is required" }),
  })
  .refine(
    (values) => {
      return values.password === values.confirm_password;
    },
    {
      message: "Passwords must match!",
      path: ["confirm_password"],
    },
  );

export const SignupSchema = z
  .object({
    email: z
      .string()
      .min(1, { message: "Email is required!" })
      .email({ message: "Invalid email address!" }),
    password: z
      .string()
      .min(1, { message: "Password is required!" })
      .refine((val) => {
        return /[a-z]/.test(val) && /[A-Z]/.test(val) && /[0-9]/.test(val);
      }),
    confirm_password: z.string(),
    accept_terms: z.boolean().default(false).optional(),
  })
  .refine(
    (values) => {
      return values.password === values.confirm_password;
    },
    {
      message: "Passwords must match!",
      path: ["confirm_password"],
    },
  );

export const CreateWorkspaceSchema = z.object({
  name: z.string().min(4, { message: "name is required" }),
});
